import React, { useContext, useEffect, useMemo } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { GraphUp, Person, Star, Wechat, Image, PersonRaisedHand, Calendar, FileText, ChevronLeft, ChevronRight } from 'react-bootstrap-icons'
import { observer } from 'mobx-react-lite'
import SidebarLinks from '../Campaign/CampaignPageParts/SIdebarParts/SidebarLinks'
import { InfluencerContext } from '../../../contexts/InfluencerContext'
import SectionTitle from '../Campaign/CampaignPageParts/SIdebarParts/SectionTitle'
import { useSidebarCollapse } from '../../../contexts/SidebarCollapseContext'

export default observer(function InfluencerSidebar() {
  const { influencerState, authentications, activePath } = useContext(InfluencerContext)
  const location = useLocation()
  const { id } = useParams()
  const { isCollapsed, toggleCollapse } = useSidebarCollapse()

  const selectedAuthentication = useMemo(() => authentications.find(authentication => +authentication.id === +id), [id, authentications, authentications.length])

  const paths = {
    overview: 'overview',
    statistics: 'statistics',
    social_posts: 'social_posts',
    similar_influencers: 'similar_influencers',
    ratings: 'ratings',
    manage: 'manage',
    collaborations: 'collaborations',
  }

  // Számítsuk ki az aktív path-ot közvetlenül a location.pathname alapján
  const computedActivePath = useMemo(() => {
    const pathname = location.pathname

    // Ellenőrizzük, hogy melyik path van a pathname-ben
    // Rendezzük hossz szerint csökkenő sorrendben, hogy a hosszabbakat (pl. similar_influencers) előbb találjuk meg
    const sortedPaths = Object.keys(paths).sort((a, b) => b.length - a.length)

    for (const path of sortedPaths) {
      // Pontos egyeztetés: a path-ot "/" karakterekkel körülvéve vagy a végén keressük
      const pathPattern = `/${path}`
      if (pathname.includes(pathPattern) || pathname.endsWith(`/${path}`)) {
        return paths[path] || path
      }
    }

    return 'overview'
  }, [location.pathname])

  useEffect(() => {
    if (influencerState.activePath !== computedActivePath) {
      influencerState.activePath = computedActivePath
    }
    document.getElementById(Object.keys(paths).find(key => paths[key] === computedActivePath))?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [computedActivePath, influencerState])

  return (
    <div className={`fixed ${isCollapsed ? 'w-16' : 'w-56'} bg-white dark:bg-rb-dark-mode border-r-1 dark:border-rb-dark-mode-lighter pt-16 h-full transition-all duration-300`}>
      {!isCollapsed && (
        <div className="px-4 flex items-center justify-between">
          <p className="text-xs text-gray-300 dark:text-gray-400 uppercase">Influencer details</p>
          <button
            onClick={toggleCollapse}
            className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white"
            title="Collapse sidebar"
          >
            <ChevronLeft className="text-sm" />
          </button>
        </div>
      )}
      {isCollapsed && (
        <div className="px-2 flex items-center justify-center py-2">
          <button
            onClick={toggleCollapse}
            className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white"
            title="Expand sidebar"
          >
            <ChevronRight className="text-sm" />
          </button>
        </div>
      )}
      <SidebarLinks text="Overview" icon={<Person/>} link={`/project_manager/authentications/${selectedAuthentication?.id}/influencer/overview`} active={computedActivePath === "overview"} />
      <SidebarLinks text="Statistics" icon={<GraphUp />} link={`/project_manager/authentications/${selectedAuthentication?.id}/influencer/statistics`} active={computedActivePath === "statistics"} />
      <SidebarLinks text="Social Posts" icon={<Image/>} link={`/project_manager/authentications/${selectedAuthentication?.id}/influencer/social_posts`} active={computedActivePath === "social_posts"} />
      <SidebarLinks text="Collaborations" icon={<FileText/>} link={`/project_manager/authentications/${selectedAuthentication?.id}/influencer/collaborations`} active={computedActivePath === "collaborations"} />
      <SidebarLinks text="Similar Influencers" icon={<PersonRaisedHand/>} link={`/project_manager/authentications/${selectedAuthentication?.id}/influencer/similar_influencers`} active={computedActivePath === "similar_influencers"} />
      <SidebarLinks text="Ratings" icon={<Star/>} link={`/project_manager/authentications/${selectedAuthentication?.id}/influencer/ratings`} active={computedActivePath === "ratings"} />
      <SidebarLinks text="Manage" icon={<Wechat/>} link={`/project_manager/authentications/${selectedAuthentication?.id}/influencer/manage`} active={computedActivePath === "manage"} />
    </div>
  )
})
